import React from "react";

export default function ToTop() {
  return (
    <div id="button">
    <img src="https://ashleysleepuniversity.com/images/to-top.svg" alt="..." />
  </div>
  );
}
